export const analyticsPageData = {
  category: "Product Page",
  label: "Product page view",
  pageSection: "Product Page",
  pageStage: "Discover",
  productListViewedLabel: "Product Page View",
};

export const analyticsPageName = (mpvId: string) => `${mpvId}:Product Page`;
